import { SHOW_PAGE_TITLE_NOTIFICATION } from '../../../constants/PostMessageTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { postMessageToParent } from '../../../post-message/postMessageToParent';
export const postShowPageTitleNotification = payload => {
  postMessageToParent(SHOW_PAGE_TITLE_NOTIFICATION, payload);
};